// extracted by mini-css-extract-plugin
export default {"title":"ProfileSettingsPage_title__Ahwje","section":"ProfileSettingsPage_section__NFC6l","formCard":"ProfileSettingsPage_formCard__dKz68"};